import React from 'react';
import { Box } from '@mui/material';
import { Appointments } from '@devexpress/dx-react-scheduler-material-ui';
import { AppointmentModel } from '@devexpress/dx-react-scheduler';

interface ContainerComponentPropsChildren {
  params: {
    data: AppointmentModel;
  };
}

interface AppointmentContainerComponentProps
  extends Appointments.ContainerProps {
  children: React.ReactElement<ContainerComponentPropsChildren>[];
}

export default function AppointmentContainerComponent(
  props: AppointmentContainerComponentProps,
) {

  return (
    <Box
      {...props}
      sx={{
        '&.MuiBox-root .Appointment-appointment': {
          borderRadius: '0.8rem',
          border: '0.1rem solid',
          borderColor: 'blue.200',
          backgroundColor: 'blue.100',
          '&:hover': {
            backgroundColor: 'blue.100',
          },
        },
      }}
    />
  );
}
